import React__default, { useContext } from 'react';
import { a as LocalizationContext } from '../../LocalizationContext-b021af8f.js';
import MessageInput from '../../ui/MessageInput.js';
import { u as useOpenChannel } from '../../OpenChannelProvider-abc4ab98.js';
import '../../stringSet-91746bf1.js';
import '../../index-353f13f3.js';
import '../../_rollupPluginBabelHelpers-8e4fae98.js';
import 'stream';
import 'prop-types';
import '../../const-09c22c50.js';
import '../../const-3f63e129.js';
import '../../ui/IconButton.js';
import '../../index-41a6f4f2.js';
import '../../index-a611bd38.js';
import '../../ui/MentionUserLabel.js';
import '../../ui/Icon.js';
import '../../index-ad4c9e58.js';
import '../../tslib.es6-83aa13f5.js';
import '../../index-4a59a866.js';
import '../../UserProfileContext-daa99f9b.js';
import '../../compareIds-48d87cc5.js';
import '../../topics-17d99dd6.js';
import '../../uuid-6d14d007.js';
import '../../useSendbirdStateContext.js';
import '../../withSendBird.js';

var MessageInputWrapper = function MessageInputWrapper(props, ref) {
  var _a = useOpenChannel(),
      currentOpenChannel = _a.currentOpenChannel,
      disabled = _a.disabled,
      handleSendMessage = _a.handleSendMessage,
      handleFileUpload = _a.handleFileUpload;

  var channel = currentOpenChannel;

  if (!channel) {
    return;
  }

  var stringSet = useContext(LocalizationContext).stringSet;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-openchannel-footer"
  }, /*#__PURE__*/React__default.createElement(MessageInput, {
    ref: ref,
    disabled: disabled,
    onSendMessage: handleSendMessage,
    onFileUpload: handleFileUpload,
    placeholder: disabled && stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED // add disabled because of muted state

  }));
};

var OpenChannelInput = /*#__PURE__*/React__default.forwardRef(MessageInputWrapper);
export { OpenChannelInput as default };